import React from 'react'
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import {withRouter} from 'react-router';
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";
import Redirect from "../../helpers/Redirect";
import Alert from "@material-ui/lab/Alert";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import Icon from "@material-ui/core/Icon";
import Env from "../../config/env";
import Api from "../../helpers/Api";
import Session from "../../helpers/Session";
// import GetDataApi from "../../helpers/GetDataApi";
// import Grid from "@material-ui/core/Grid";
// import AppInputText from "../../ui/AppInputText";
// import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
import AppToast from "../../ui/AppToast";
import IconButton from "@material-ui/core/IconButton";
// import RespuestaSolicitud from "../cuenta-nueva/RespuestaSolicitud";
import MensajeGestor from "../cuenta-nueva/MensajeGestor";
import {confirmAlert} from "react-confirm-alert";
import InscripcionProveedoresRespuestaSolicitud from './InscripcionProveedoresRespuestaSolicitud';

const initialForm = {

    radicado: {
        key: 'radicado',
        value: '',
        required: false
    },
    nombreProyecto: {
        key: 'nombreProyecto',
        value: '',
        required: false
    },
    estado: {
        key: 'estado',
        value: '',
        required: false
    },
};

class ListarInscripcionProveedores extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            form: initialForm,
            url: '',
            openDialog: false,
            openDialogRespuestas: false,
            openDialogConfirmar: false,
            openDialogMensajeGestor: false,
            solicitudID: null,
            loadData: {
                estados: []
            },
            data: [],
            userLogued: null,
            solicitudSelected: null,
        };

    }

    async componentDidMount() {
        this.loadControls();
        this.buscar();
        this.setState({
            userLogued: Session.getLogin()
        });
    }

    loadControls = async () => {
        const response = await Api.get(`${Env.UrlBackendCuentaNueva}/solicitud/load-controls-list`);
        if (response.success) {
            this.setState({
                loadData: {
                    ...this.state.loadData,
                    estados: response.data.estados,
                }
            });
        } else {
            AppToast(response.message, false);
        }
    }

    handleChange = async (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }
        });
    }

    buscar = async () => {
        const user = Session.getLogin();
        console.log(user)
        // let params = GetDataApi(this.state.form);
        // params = {
        //     ...params,
        //     user: user.terceroID,
        //     // numero_documento: user.terceroDocumento,
        // };
        // const jsonParams = JSON.stringify(params);
        const response = await Api.get(`${Env.UrlBackend}/provider-registration/listar?user=${user.terceroID}`);
        this.setState({
            data: response.data
        });
    }

    limpiar = () => {
        this.setState({
            form: initialForm
        }, () => {
            this.buscar();
        });
    }

    handleOpenDialog = () => {
        this.setState({
            openDialog: true
        });
    }

    handleCloseDialog = () => {
        this.setState({
            openDialog: false
        })
    }

    handleInscripcionProveedores = () => {
        this.setState({
            url: '/provider-registration'
        });
    }

    openCuentaNuevaForm = (tipoUsuario) => {
        this.setState({
            url: `/new-account/${tipoUsuario}`
        });
    }

    openDocumentacionForm = (solicitud) => {
        this.setState({
            url: `/new-account/documentation/${solicitud.id}`
        });
    }

    handleOpenDialogRespuestas = (value) => {
        this.setState({
            openDialogRespuestas: true,
            solicitudID: value.radicado,
            solicitudSelected: value
        });
    }

    handleCloseDialogRespuestas = () => {
        this.setState({
            openDialogRespuestas: false
        });
    }

    handleOpenDialogMensajeGestor = (val) => {
        this.setState({
            openDialogMensajeGestor: true,
            solicitudSelected: val
        });
    }

    handleCloseDialogMensajeGestor = () => {
        this.setState({
            openDialogMensajeGestor: false
        });
    }

    handleOpenDialogConfirmar = (val) => {
        this.setState({
            openDialogConfirmar: true,
            solicitudSelected: val
        });
    }

    handleCloseDialogConfirmar = () => {
        this.setState({
            openDialogConfirmar: false
        });
    }

    getColor(estado) {
		if (estado ===2) {
			return 'RGB(253,253,150)';
		} else if (estado === 3) {
			return 'RGB(152,195,119,0.6)';
		} else if (estado ===4) {
			return 'RGB(255,55,55)';
		} else if (estado ===6) {
			return 'RGBA(255,196,55)';
		} 
	}

    async confirmarSolicitud() {
        const params = {
            solicitudID: this.state.solicitudSelected?.id
        };
        const data = await Api.post(`${Env.UrlBackendCuentaNueva}/solicitud/confirmar-electricista`, params);
        if (data.success) {
            AppToast(data.message, true);
            this.buscar();
            this.handleCloseDialogConfirmar();
        } else {
            AppToast(data.message, false);
        }
    }

    async rechazarSolicitud() {

        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h3>¿Está seguro(a) de rechazar la solicitud? <br /> Esta acción no se puede reversar.</h3>
                        <button onClick={onClose}>No</button>
                        <button className='custom-ui-btn-si'
                            onClick={async () => {

                                const params = {
                                    solicitudID: this.state.solicitudSelected?.id,
                                    solicitudPasoID: this.state.solicitudSelected?.solicitud_paso_id
                                };
                                const data = await Api.post(`${Env.UrlBackendCuentaNueva}/solicitud/rechazar-electricista`, params);
                                if (data.success) {
                                    AppToast(data.message, true);
                                    this.buscar();
                                    this.handleCloseDialogConfirmar();
                                } else {
                                    AppToast(data.message, false);
                                }

                                onClose();

                            }}
                        >
                            Si
                        </button>
                    </div>
                );
            }
        });
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <Redirect url={this.state.url}/>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'provider-registration-list',
                            label: 'Inscripción de proveedores'
                        }
                    ]}
                    actual='Listado'
                />

                <h2>
                    <span>LISTADO INSCRIPCIÓN DE PROVEEDORES</span>
                </h2>

                <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}}>
                    {
                        this.state.data.length === 0 ?
                            <Alert severity="info">¡No se encontraron registros!</Alert> :
                            <table className='custom-table'>
                                <thead>
                                <tr>
                                    <th style={{width: '10%'}}>Radicado</th>
                                    <th style={{width: '12%'}}>Tipo Persona</th>
                                    <th>Documento</th>
                                    <th>Nombre</th>
                                    <th>Departamento</th>
                                    <th>Municipio</th>
                                    <th style={{width: '13%'}}>Fecha Registro</th>
                                    <th>Estado</th>
                                    <th style={{width: '5%'}}>Acción</th>
                                </tr>
                                </thead>
                                <tbody>

                                {this.state.data.map((val, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{val?.radicado}</td>
                                            <td>{ (val?.tipoPersona==='1' ? 'Natural' : 'Juridica') }</td>
                                            <td>{val?.numeroDocumento}-{val?.digitoVerificacion}</td>
                                            <td>{val?.razonSocial}</td>
                                            <td>{val?.departamento?.nombre}</td>
                                            <td>{val?.municipio?.nombre}</td>
                                            <td>{val?.fechaCreacion}</td>
                                            <td  style={{backgroundColor: this.getColor(val?.estado?.id)}}  >{ (val?.estado?.nombre)} </td>
                                            <td>
                                                <Tooltip title="Ver Gestión">
                                                    <IconButton color="secondary" onClick={() => {
                                                        this.handleOpenDialogRespuestas(val)
                                                    }}>
                                                        <Icon>speaker_notes</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </td>
                                        </tr>
                                    );
                                })}

                                </tbody>
                            </table>
                    }

                </div>

                <Tooltip title="Radicar inscripción de proveedores">
                    <Fab onClick={this.handleInscripcionProveedores} color="primary" aria-label="add" className='float-button'>
                        <AddIcon/>
                    </Fab>
                </Tooltip>

                <Dialog onClose={this.handleCloseDialog} aria-labelledby="customized-dialog-title"
                        open={this.state.openDialog}>
                    <DialogContent style={{padding: '0px'}}>

                        <h3 style={{textAlign: 'center'}}>Por favor seleccione el tipo de usuario.</h3>

                        <div style={{width: '400px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                startIcon={<AccessibilityIcon/>}
                                style={{margin: '10px'}}
                                onClick={() => {
                                    this.openCuentaNuevaForm(Env.tipoUsuario.propietario)
                                }}
                            >
                                Propietario
                            </Button>

                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                startIcon={<Icon>engineering</Icon>}
                                style={{margin: '10px'}}
                                onClick={() => {
                                    this.openCuentaNuevaForm(Env.tipoUsuario.electricista)
                                }}
                            >
                                Electricista
                            </Button>

                        </div>


                    </DialogContent>
                </Dialog>

                <Dialog fullScreen open={this.state.openDialogRespuestas} onClose={this.handleCloseDialogRespuestas}>

                    <InscripcionProveedoresRespuestaSolicitud
                        onClose={this.handleCloseDialogRespuestas}
                        solicitud={this.state.solicitudSelected}
                        solicitudID={this.state.solicitudID}
                    />

                </Dialog>

                <Dialog onClose={this.handleCloseDialogMensajeGestor} aria-labelledby="customized-dialog-title"
                        open={this.state.openDialogMensajeGestor}>

                    <MensajeGestor
                        onClose={this.handleCloseDialogMensajeGestor}
                        solicitud={this.state.solicitudSelected}
                    />

                </Dialog>

                <Dialog onClose={this.handleCloseDialogConfirmar} aria-labelledby="customized-dialog-title"
                        open={this.state.openDialogConfirmar}>

                    <div style={{padding: '20px', textAlign: 'center'}}>

                        <h3>Confirmar la solicitud con radicado: <span
                            style={{color: '#0098DB'}}> {this.state.solicitudSelected?.radicado} </span>
                        </h3>

                        <div style={{textAlign: 'left'}}>
                            <p>* Usted como electricista, deberá confirmar la solicitud para que inicie el proceso de la
                                nueva cuenta.</p>

                            <p>* Recuerde que tiene plazo
                                hasta: <b>{this.state.solicitudSelected?.maxima_fecha_confirmacion}</b></p>

                            <p>* Si no realiza este proceso en el plazo establecido, la solicitud será cancelada de
                                forma automática.</p>
                        </div>

                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<Icon>done</Icon>}
                            style={{margin: '10px', backgroundColor: '#4caf50', color: 'white'}}
                            onClick={() => {
                                this.confirmarSolicitud()
                            }}
                        >
                            Confirmar
                        </Button>

                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<Icon>block</Icon>}
                            style={{margin: '10px', backgroundColor: '#e53935', color: 'white'}}
                            onClick={() => {
                                this.rechazarSolicitud()
                            }}
                        >
                            Rechazar
                        </Button>

                    </div>

                </Dialog>

            </div>
        );
    }
}

export default withRouter(ListarInscripcionProveedores)
